// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"PreviewStep_tableWrapper__2hzys","pagination":"PreviewStep_pagination__3Zrpy","contentContainer":"PreviewStep_contentContainer__3-A3g"};